// import * as React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Announcements from "../announcements/Announcements";
import instance from "../../axios";
import { useSelector, useDispatch } from "react-redux";
import {
  Stack,
  Autocomplete,
  TextField,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import {
  setUserCategories,
  setUserSubcategories,
} from "../../redux/reducers/categoriesSlice";
import axios from "axios";

function Main() {
  const [categoryInputValue, setCategoryInputValue] = useState(0);
  const [subCategoryInputValue, setSubCategoryInputValue] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPage, setNextPage] = useState(2);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [ad_status, set_ad_status] = useState(0);
  const { categoriesArray, subCategoriesArr } = useSelector(
    (state) => state.categories
  );

  // Telegram id
  const tgId =
    window?.Telegram?.WebApp?.initDataUnsafe?.user?.id | "1598016165";

  // Dispatch
  const dispatch = useDispatch();

  ///////////
  const observer = useRef();
  const lastElement = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prev) => {
            if (prev < totalPages && !loading) {
              return prev + 1;
            }
            return prev;
          });
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );
  /////////////////////////////////////
  ////////////////////////////////////

  const handleChange = (event) => {
    setCurrentPage(1);
    if (event.target.value === 0) {
      setCategoryInputValue(event.target.value);
    } else {
      setCategoryInputValue(event.target.value);
      setSubCategoryInputValue(0);
    }
  };
  const subHandleChange = (event) => {
    setCurrentPage(1);
    setSubCategoryInputValue(event.target.value);
  };

  /////////////////////////////////////
  ////////////////////////////////////
  /////////////// get categories
  useEffect(() => {
    instance
      .get(`api/categories`, {
        headers: {
          Authorization: `Telegram ${tgId}`,
        },
      })
      .then((res) => {
        dispatch(setUserCategories(res.data.data.categories));
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (categoryInputValue !== 0) {
      instance
        .get(`api/categories/${categoryInputValue}`, {
          headers: {
            Authorization: `Telegram ${tgId}`,
          },
        })
        .then((res) => {
          dispatch(setUserSubcategories(res.data.data.category.children));
        })
        .catch((err) => {});
    }
  }, [categoryInputValue]);

  /////////////////////////////////////
  ////////////////////////////////////

  //////////////////////////////////////////
  function getData() {
    setLoading(true);
    let url =
      categoryInputValue == 0
        ? ``
        : subCategoryInputValue != 0
        ? `&category_id=${subCategoryInputValue}`
        : `&category_id=${categoryInputValue}`;

    let query = search
      ? `/results?search_query=${search}`
      : search == ""
      ? `?page=${currentPage}`
      : `/results?search_query=${search}&page=${currentPage}`;

    let status = ad_status == 0 ? "" : `&status=${ad_status}`;

    // `api/ads${query}${status}${url}`
    let cancel;
    instance
      .get(`api/ads${query}${status}${url}`, {
        headers: {
          Authorization: `Telegram ${tgId}`,
        },
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      })
      .then((res) => {
        if (currentPage === nextPage) {
          setAnnouncements((prev) => {
            return [...new Set([...prev, ...res.data.data.ads])];
          });
          setNextPage((prev) => prev + 1);
        } else {
          setAnnouncements(res.data.data.ads);
        }
        setTotalPages(res.data.data.pagination.pages);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
      })
      .finally((f) => {
        setLoading(false);
      });

    return () => cancel();
  }

  useEffect(() => {
    getData();
    setCurrentPage(1);
    setNextPage(2);
  }, [categoryInputValue, subCategoryInputValue, search, ad_status]);
  //////////////////////////////////////////

  useEffect(() => {
    if (!loading) {
      getData();
    }
  }, [currentPage]);

  //////////////////////////////////////////
  useEffect(() => {
    setAnnouncements([]);
  }, [categoryInputValue, subCategoryInputValue, ad_status, search]);
  /////////////////////////////////////////////

  /////////////////////////////////////////////
  /////////////////////////////////////////////
  return (
    <div className="bg-gray">
      <div className="container mx-auto p-2 pt-5">
        <h1
          className="my-4 text-xl"
          style={{ width: "336px", height: "32px", fontWeight: "400" }}>
          E'lonlar
        </h1>
        <Stack sx={{ background: "white", width: 300 }} my={2}>
          <Autocomplete
            size="small"
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={[
              ...new Set(
                announcements.map((el) => {
                  return el.name;
                })
              ),
            ]?.map((option) => option)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Qidirish"
                value={search}
                // onChange={(e) => {
                //   setSearch(e.target.value);
                // }}
                onSelect={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  size: "small",
                }}
              />
            )}
          />
        </Stack>
        <FormControl>
          <FormLabel>Statuslar</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={ad_status}
            onChange={(e) => {
              set_ad_status(e.target.value);
              setAnnouncements([]);
              setCurrentPage(1);
            }}>
            <FormControlLabel value={0} control={<Radio />} label="Barchasi" />
            <FormControlLabel value={1} control={<Radio />} label="Aktiv" />
            <FormControlLabel value={2} control={<Radio />} label="Noaktiv" />
          </RadioGroup>
        </FormControl>
        <div className="flex justify-between space-x-2 mt-2">
          <div className="mb-5">
            <Box sx={{ minWidth: 166 }}>
              <FormControl fullWidth style={{ backgroundColor: "#fff" }}>
                <InputLabel id="demo-simple-select-label" className="font-bold">
                  Kategoriya
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={categoryInputValue}
                  label="Kategoriya"
                  onChange={handleChange}>
                  <MenuItem key={0} value={0}>
                    Hammasi
                  </MenuItem>
                  {categoriesArray?.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </div>
          <div className="mb-5">
            {categoryInputValue != 0 && subCategoriesArr?.length != 0 ? (
              <Box sx={{ minWidth: 166 }}>
                <FormControl
                  style={{ backgroundColor: "#fff" }}
                  fullWidth
                  disabled={!categoryInputValue}>
                  <InputLabel id="demo-simple-select-label">
                    Kategoriya
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={subCategoryInputValue}
                    label="Kategoriya"
                    onChange={subHandleChange}>
                    {subCategoriesArr?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            ) : (
              <></>
            )}
          </div>
        </div>
        <hr className="w-full bg-gray-300 mb-2 h-0.5" />
        <Announcements
          data={announcements}
          loading={loading}
          lastElement={lastElement}
        />
      </div>
    </div>
  );
}

export default Main;
